import {Base64} from './Base64';

export const decodePayload = (payload: string): string =>
  decodeURIComponent(
    Base64.decode(payload)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );
